import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import * as permissionKind from '../../../../shared/permissions';
import { useAccount } from '../../../components/contexts/AccountContextManager';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import hasPermissions from '../../../utilities/hasPermissions';
import useGoTo from '../../../utilities/useGoTo';
import InsuranceProductList from './InsuranceProductList';

const InsuranceProductListPage = () => {
    const { t } = useTranslation('insuranceProductList');
    const { permissions: accountPermissions } = useAccount();

    const goToNewInsuranceProductPage = useGoTo('/admin/insuranceProducts/add');

    const extra = hasPermissions(accountPermissions, [permissionKind.createInsuranceProduct]) && (
        <Button icon={<PlusOutlined />} onClick={goToNewInsuranceProductPage} type="primary">
            {t('insuranceProductList:actions.newInsuranceProduct')}
        </Button>
    );

    return (
        <ConsolePageWithHeader extra={extra} title={t('insuranceProductList:title')}>
            <InsuranceProductList />
        </ConsolePageWithHeader>
    );
};

export default InsuranceProductListPage;
